import lodgingCancellationPolicyGraphQl from '../api/lodgingCancellationPolicyGraphQl';
import lodgingCancellationPolicyActions from '../actions/lodgingCancellationPolicyActions';
import {getIsIpmNonGuaranteedPricing} from '../selectors/listing';

async function updateIfDateChanged(store, action = {payload: {}}) {
    const state = store.getState();
    const {
        listingReducer: {unitApiUrl: unitUrl},
        systemReducer: {locale}
    } = state;
    const {fieldsChanged, isInitialPageLoad} = action.payload;

    if (!isInitialPageLoad && fieldsChanged.arriveDateText) {
        const data = await lodgingCancellationPolicyGraphQl({
            arrivalDate: fieldsChanged.arriveDateText,
            locale,
            unitUrl,
            isIpmNonGuaranteedPricing: getIsIpmNonGuaranteedPricing(state)
        });

        if (data && data.houseRules) {
            store.dispatch(
                lodgingCancellationPolicyActions.updateLodgingCancellationPolicy(
                    data.houseRules.lodgingCancellationPolicy
                )
            );
        } else {
            store.dispatch(lodgingCancellationPolicyActions.updateLodgingCancellationPolicy(null));
        }
    }
}

export default updateIfDateChanged;
